import { Suspense, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { RootState } from '../services/store';
import { MeRoutesEnum, RoutesEnum } from '../models/enums/routes.enum';
import { useGlobals } from '../contexts/appContext';
import { getUserSettings } from '../services/userService';
import { User } from '../models/user';
import ConsoleHelper from '../functions/consoleHelper';
import { UserAccountTypeEnum } from '../models/enums/userAccountType.enum';
import { buildLoginSearch } from '../functions/returnUrl';
import { useSilentSignin } from '../hooks/useSilentSignin';

const RequireUser = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const user = useSelector((state: RootState) => state.oidc.user);
  const { setCurrentUser } = useGlobals();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      const result = await getUserSettings();
      const userResult = result.data as User;
      setCurrentUser(userResult);
      ConsoleHelper.log('USER/ME', result.data);
      setIsLoading(false);
    };
    if (user && !user.expired && user.profile.accountType === UserAccountTypeEnum.User) {
      // Användaren kan dyka upp efter en tyst inloggning, och då ska sidan vänta på
      // user/me i stället för att ritas med tom användare.
      setIsLoading(true);
      fetchUser();
    } else {
      setIsLoading(false);
    }
  }, [user, setCurrentUser]);

  // En ny flik har tom sessionStorage och saknar därför användaren även när man redan är
  // inloggad. Hämta inloggningen tyst innan vi ger upp och visar inloggningssidan.
  const isSigningIn = useSilentSignin(!user || user.expired);

  if (isLoading || isSigningIn) {
    return <div />;
  }
  if (user && !user.expired && user.profile.accountType === UserAccountTypeEnum.User) {
    return <Suspense fallback={<div />}>{children}</Suspense>;
  }
  if (user && !user.expired && user.profile.accountType === UserAccountTypeEnum.Member) {
    return <Navigate to={MeRoutesEnum.MemberDashboard} state={{ from: location }} replace />;
  }
  return <Navigate to={`${RoutesEnum.Login}${buildLoginSearch(location)}`} state={{ from: location }} replace />;
};

export default RequireUser;
